// Site-wide lightbox: works for any <img class="js-lightbox-image"> on the page
initLightbox(768);

function initLightbox(minWidth = 768) {
  // Guard against double-init if this ever gets called twice
  if (window.__pccLightboxInit) return;
  window.__pccLightboxInit = true;

  const isDesktop = () => window.matchMedia(`(min-width: ${minWidth}px)`).matches;

  // Ensure a single lightbox overlay exists on <body>.
  // - If the scrollytelling block already rendered one, reuse the first and remove any dupes.
  // - Otherwise, create one.
  let lightbox = document.querySelector('.js-lightbox');
  if (lightbox) {
    // Move to body so it escapes overflow:hidden / transformed ancestors
    if (lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }
    // Remove any additional duplicates rendered by multiple blocks
    document.querySelectorAll('.js-lightbox').forEach((el) => {
      if (el !== lightbox) el.remove();
    });
  } else {
    lightbox = document.createElement('div');
    lightbox.className = 'pcc-lightbox js-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.setAttribute('aria-label', 'Image preview');
    lightbox.innerHTML = `
      <button type="button" class="pcc-lightbox__close js-lightbox-close" aria-label="Close">&times;</button>
      <img class="pcc-lightbox__img js-lightbox-img" src="" alt="" />
    `;
    document.body.appendChild(lightbox);
  }

  const lockScroll = () => {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.classList.add('pcc-lightbox-open');
  };

  const unlockScroll = () => {
    document.body.classList.remove('pcc-lightbox-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };

  const openLightbox = (src, alt) => {
    if (!src) return;
    const img = lightbox.querySelector('.js-lightbox-img');
    img.src = src;
    img.alt = alt || '';
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    lockScroll();
  };

  const closeLightbox = () => {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    unlockScroll();
    setTimeout(() => {
      if (!lightbox.classList.contains('is-open')) {
        const img = lightbox.querySelector('.js-lightbox-img');
        if (img) img.src = '';
      }
    }, 300);
  };

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.js-lightbox-image');
    if (trigger && isDesktop()) {
      // Resolve to the underlying <img>:
      // - if trigger IS an <img>, use it directly
      // - if trigger is a <picture> (or any wrapper), find the inner <img>
      const imgEl = trigger.tagName === 'IMG'
        ? trigger
        : trigger.querySelector('img');
      if (!imgEl) return;

      // For <picture>, currentSrc reflects the <source> the browser chose;
      // for a plain <img>, currentSrc equals the resolved src.
      const src = imgEl.currentSrc || imgEl.getAttribute('src') || imgEl.src;
      if (!src) return;

      e.preventDefault();
      openLightbox(src, imgEl.getAttribute('alt') || '');
      return;
    }
    if (!lightbox.classList.contains('is-open')) return;
    if (e.target === lightbox || e.target.classList.contains('js-lightbox-close')) {
      closeLightbox();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && lightbox.classList.contains('is-open')) {
      closeLightbox();
    }
  });
}
